module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAmBAMAAABJxLRpAAAAMFBMVEUAAADw8PDw8PDw8PDw8PDw8PDw8PDw8PDy8vLy8vLy8vLx8fHx8fHx8fHx8fHx8fHEtTZQAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAArElEQVQoz+3OuxHCMBgDYJMECHmZDTICDOE9WIER2IBRYAPYIKvQpiAC7MRSk6OgxZX03f1nGfPlJZcrS9ZNKQfoJTCmDcQrTJ5CPEf0Th3RLcRbOsRTRLfqLT0kbOV2eKcixLvnJpRTvHyGXw++9Lx8yEhfFiEePa/4Vc0BcZpE5/axDM4Zsxtn+v3nqRhzUwcdP3hGT9TX9KV6Sc/VG3qhbunljFczXv/9814mYjp3F9jCfQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/zhuangshi.png
// module id = 8+cw
// module chunks = 69